import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import Pagination from "../../../../components/Pagination";
import pdf from "../../../../assets/img/pdf.png";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const SMS_Students = () => {
  const [data, setData] = useState([]);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(25);
  const totalItems = data?.meta?.pagination?.total || 0;
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(
      getAPIPath(currentDomain)?.students + `&pagination[page]=${currentPage}`,
      setData
    );
  }, [currentDomain, currentPage]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Helmet>
        <title>Students | SMS | JNTU Anantapur</title>
        <meta
          name="description"
          content="Students information of School of Management Studies, JNTUA"
        />
        <meta
          name="keywords"
          content="Students, SMS, School of Management Studies, JNTUA, Batches"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Students"
          pageName="Students"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title">Students Information</h3>
                    <div className="overflow-x">
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Academic Year</th>
                            <th scope="col">Program Information</th>
                            <th scope="col">Placement Brochure</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.map((obj, index) => (
                            <tr key={obj.id}>
                              <td>
                                {((currentPage - 1) * itemsPerPage + index + 1)
                                  .toString()
                                  .padStart(2, "0")}
                                .
                              </td>
                              <td>
                                <strong style={{ color: "#ff6600" }}>
                                  {obj?.attributes?.year}
                                </strong>
                              </td>
                              <td>
                                {obj?.attributes?.program_pdf?.length > 0 ? (
                                  <div className="d-flex flex-wrap gap-2">
                                    {obj.attributes.program_pdf.map((program, programIndex) => (
                                      <div key={program.id} className="d-flex flex-column align-items-center me-3 mb-2">
                                        {program.pdf?.data ? (
                                          <a
                                            href={`${process.env.REACT_APP_STRAPI_API_URL}${program.pdf.data.attributes.url}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            title={`${program.program_name} Program Details`}
                                            className="text-decoration-none"
                                          >
                                            <img
                                              alt={`${program.program_name} PDF`}
                                              title={`View ${program.program_name} Details`}
                                              src={pdf}
                                              style={{
                                                width: "25px",
                                                height: "25px",
                                                marginBottom: "5px",
                                              }}
                                            />
                                            <small style={{ color: "#ff6600", fontSize: "10px", display: "block", textAlign: "center" }}>
                                              {program.program_name}
                                            </small>
                                          </a>
                                        ) : (
                                          <div className="d-flex flex-column align-items-center">
                                            <img
                                              alt="No PDF"
                                              src={pdf}
                                              style={{
                                                width: "25px",
                                                height: "25px",
                                                marginBottom: "5px",
                                                opacity: "0.3"
                                              }}
                                            />
                                            <small style={{ color: "#999", fontSize: "10px", textAlign: "center" }}>
                                              {program.program_name}
                                              <br />
                                              <span style={{ fontSize: "8px" }}>Not Available</span>
                                            </small>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <span 
                                    style={{ 
                                      color: "#999", 
                                      fontStyle: "italic",
                                      fontSize: "12px"
                                    }}
                                  >
                                    No Programs Available
                                  </span>
                                )}
                              </td>
                              <td align="center">
                                {obj?.attributes?.placement_brochure?.data?.attributes?.url ? (
                                  <a
                                    href={`${process.env.REACT_APP_STRAPI_API_URL}${obj.attributes.placement_brochure.data.attributes.url}`}
                                    className="d-flex flex-column align-items-center"
                                    target="_blank"
                                    rel="noreferrer"
                                    title={`Placement Brochure for ${obj?.attributes?.year}`}
                                  >
                                    <img
                                      alt="Placement Brochure PDF"
                                      title="View Placement Brochure"
                                      src={pdf}
                                      className="mb-5"
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        marginLeft: "10px",
                                      }}
                                    />
                                    <small style={{ color: "#666", fontSize: "11px" }}>
                                      Placement Brochure
                                    </small>
                                  </a>
                                ) : (
                                  <span 
                                    style={{ 
                                      color: "#999", 
                                      fontStyle: "italic",
                                      fontSize: "12px"
                                    }}
                                  >
                                    Not Available
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                          {(!data?.data || data?.data?.length === 0) && (
                            <tr>
                              <td colSpan="4" className="text-center" style={{ padding: "40px" }}>
                                <div style={{ color: "#666", fontSize: "16px" }}>
                                  <i className="fas fa-users" style={{ fontSize: "48px", marginBottom: "20px", color: "#ddd" }}></i>
                                  <br />
                                  No student information found.
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {totalItems > itemsPerPage && (
                      <Pagination
                        currentPage={currentPage}
                        paginate={paginate}
                        arrayLength={Math.ceil(totalItems / itemsPerPage)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SMS_Students;
